import { render, staticRenderFns } from "./KCdialog.vue?vue&type=template&id=63db080a&scoped=true&"
import script from "./KCdialog.vue?vue&type=script&lang=js&"
export * from "./KCdialog.vue?vue&type=script&lang=js&"
import style0 from "./KCdialog.vue?vue&type=style&index=0&id=63db080a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db080a",
  null
  
)

export default component.exports